import { Component, input } from "@angular/core";

@Component({
  selector: "app-button-badge",
  imports: [],
  templateUrl: "./button-badge.component.html",
  styleUrls: ["./button-badge.component.scss"],
})
export class ButtonBadgeComponent {
  count = input<number | null>(0);
}
